import React, { useState } from "react"
import Dialog from "@material-ui/core/Dialog"
import Slide from "@material-ui/core/Slide"

import CardWithHeader from "components/CardWithHeader"
import ImportantMessage from "components/ImportantMessage"
import BodyText from "components/BodyText"
import BigButton from "components/BigButton"
import Icon from "components/Icon"
import RequiresRegistration from "components/RequiresRegistration"
import WhenLoggedIn from "components/WhenLoggedIn"
import WhenNotLoggedIn from "components/WhenNotLoggedIn"

import ClearIcon from "@material-ui/icons/Clear"

import LockIcon from "icons/LockIcon"
import ArticleIcon from "icons/ArticleIcon"
import CalendarIcon from "icons/CalendarIcon"
import { FormattedMessage, } from "react-intl"

import styles from "./CreatePage.css"
import { useDispatch } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"

import { Tooltip, IconButton } from "@material-ui/core"
import { useCircleMembership } from "circle/circle.selectors"
import { PostType } from "posts/posts.types"
import { DiscussionIcon } from 'navigation/navigation-places'
import { IconContext } from "react-icons"
import { CreateAssetDialog, FormDataContextProvider, useCreateDraftToEditFn } from "lib-core"
import { bindActionCreators } from 'redux'
import { loadGroupPosts } from 'state/actions/posts'
import { BiBuildingHouse as AssetIcon } from 'react-icons/bi'


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export const CreateModal = ({ open, handleClose: onClose }) => {
  const history = useHistory()
  const location = useLocation()
  const circleId = location.pathname.split("/")[2]
  const [assetDialogOpen, setAssetDialogOpen] = useState(false)
  const createDraft = useCreateDraftToEditFn()
  const createPost = async (type: PostType) => {
    const draft = await createDraft({
      type,
      group: { group: circleId } as any,
    })
    history.push(`/profile/drafts/_edit/${type}/` + draft._id)
  }
  const membership = useCircleMembership()
  const dispatch = useDispatch()

  if (!open) {
    return null
  }

  if (assetDialogOpen) {
    return (
      <FormDataContextProvider circleId={circleId}>
        <CreateAssetDialog open={assetDialogOpen} onClose={() => {
          const load = bindActionCreators(loadGroupPosts, dispatch)
          load({ group: circleId })
          onClose()
          setAssetDialogOpen(false)
        }} />
      </FormDataContextProvider>
    )
  }


  const importDocument = () => {
    const payload: any = {}

    if (circleId) {
      payload.group = circleId
      payload.postType = "article"
    }

    dispatch({
      type: "profile/drafts/_import/public",
      payload,
    })
  }

  const fillForm = () => {
    setAssetDialogOpen(true)
  }

  const isAdmin = membership?.role === 'ADMIN'
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
    >
      <div style={{ maxHeight: "100vh" }}>
        <div style={{ marginTop: 5, marginLeft: 15 }}>
          <Tooltip title={<FormattedMessage id="close" />}>
            <IconButton onClick={() => onClose()}>
              <ClearIcon style={{ fontSize: 30 }} />
            </IconButton>
          </Tooltip>
        </div>
        <WhenLoggedIn>
          <div className={styles.create_page}>
            <CardWithHeader title="compose.new.new_public_post" icon={LockIcon}>
              <ImportantMessage i18nKey="compose.new.warning" />
              <BodyText i18nKey="compose.new.what" />
              <IconContext.Provider value={{ size: "1em" }}>
                <div className={styles.options}>
                  <BigButton
                    onClick={() => createPost("article")}
                    icon={<Icon icon={ArticleIcon} />}
                    label="compose.new.post_an_article"
                  />
                  <BigButton
                    onClick={importDocument}
                    icon={<Icon icon={ArticleIcon} />}
                    label="compose.new.import_a_document"
                  />

                  <BigButton
                    onClick={() => createPost("discussion")}
                    icon={<Icon icon={DiscussionIcon} />}
                    label="StartaDiscussion"
                  />

                  {isAdmin && <BigButton
                    disabled={!circleId}
                    onClick={fillForm}
                    icon={<Icon icon={AssetIcon} />}
                  >Record an asset (beta)</BigButton>}

                  <BigButton
                    disabled={!circleId}
                    onClick={() => createPost("event")}
                    icon={<Icon icon={CalendarIcon} />}
                    label="compose.new.announce_an_event"
                  />
                </div>
              </IconContext.Provider>
            </CardWithHeader>
          </div>
        </WhenLoggedIn>

        <WhenNotLoggedIn>
          <RequiresRegistration />
        </WhenNotLoggedIn>
      </div>
    </Dialog>
  )
}

export default CreateModal
